import { useEffect, useMemo } from 'react';

import Tooltip from '@mui/material/Tooltip';

import { MISCONCEPTIONS } from 'entities/Charts/constants';
import { ChartFilterProps } from 'entities/Charts/sdk';
import { useMisconceptionsCoOccurrenceChartData } from 'entities/Charts/sdk';

import { notifyError } from 'utils/notifications';

const xLabelsFull = MISCONCEPTIONS;
const yLabelsFull = MISCONCEPTIONS;

const xLabelsShort = [
  'Computation Error',
  'Precision Error',
  'Conceptual Misunderstanding',
  'Representational Error',
  'Insufficient Explanation',
  'Incomplete',
  'Unable to Diagnose',
  'DNASQ',
  'N/A'
];

const yLabelsShort = xLabelsShort;

export const Heatmap = ({ filters }: { filters: ChartFilterProps }) => {
  const { data, isLoading } = useMisconceptionsCoOccurrenceChartData({
    filters
  });

  const messageForUser = useMemo(() => {
    if (data?.is_suppressed) {
      return 'You cannot view data for demographic subgroups smaller than 10 students!';
    }
    return '';
  }, [data]);

  useEffect(() => {
    if (
      messageForUser ===
      'You cannot view data for demographic subgroups smaller than 10 students!'
    ) {
      notifyError({ error: messageForUser });
    }
  }, [messageForUser]);

  return (
    <>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        data?.results && (
          <div className="m-10 overflow-x-auto">
            <div className={'flex'}>
              <div className="flex cursor-pointer flex-col">
                {yLabelsFull.map((fullLabel, i) => (
                  <Tooltip
                    title={fullLabel}
                    key={`y-tooltip-${i}`}
                    arrow
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -20]
                            }
                          }
                        ]
                      }
                    }}
                  >
                    <div className="flex h-[60px] w-[140px] items-center justify-end pr-2 text-right text-[12px]">
                      {yLabelsShort[i]}
                    </div>
                  </Tooltip>
                ))}
              </div>

              <div className="flex flex-col">
                {data?.results.map((row, rowIndex) => (
                  <div className="flex" key={`row-${rowIndex}`}>
                    {row.map((value, colIndex) => {
                      const intensity = value / 500;
                      const backgroundColor = `rgba(0, 0, 255, ${intensity})`;
                      const textColor = intensity > 0.5 ? 'white' : 'black';
                      return (
                        <div
                          key={`cell-${rowIndex}-${colIndex}`}
                          className="flex h-[60px] w-[80px] items-center justify-center border border-[#eee] text-[14px]"
                          style={{ backgroundColor, color: textColor }}
                        >
                          {value}
                        </div>
                      );
                    })}
                  </div>
                ))}

                <div className="mt-2 flex cursor-pointer">
                  {xLabelsFull.map((fullLabel, i) => (
                    <Tooltip title={fullLabel} key={`x-tooltip-${i}`} arrow>
                      <div className="w-[80px] overflow-hidden text-center text-[12px] text-ellipsis whitespace-nowrap">
                        {xLabelsShort[i]}
                      </div>
                    </Tooltip>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default Heatmap;
